// Purblic routes
export const HOME = '/'
export const SEARCH = '/sok'
export const LOGIN = '/login'
export const ORGANISATION = '/organisation' // skapa komp som ska läsa data från Piranha
export const RESET_PASSWORD = '/aterstall-losenord'
export const REQUEST_ACCOUNT = '/ansok-om-konto'

// Dynamic routes
export const DYNAMIC_PAGE = '/:page/*'
export const DYNAMIC_POST = '/:containerpage/:archive/:post'

// Protected routes
export const PREVIEW_ORGANISATION = '/granska-organisation' // skapa komp
export const EDIT_ORGANISATION = '/redigera-organisation' // skapa komp
export const PREVIEW_ACTIVITY = '/granska-aktivitet' // skapa komp
export const CREATE_ACTIVITY = '/skapa-aktivitet'
export const EDIT_ACTIVITY = '/redigera-aktivitet'
export const MY_PAGE = '/min-sida'
